// extracted by mini-css-extract-plugin
export default {"number":"Screen_number__GKQCC","header":"Screen_header__ms+79","default":"Screen_default__1WwGz"};